import { BaseComunicationProvider } from './basecomunication';
import { Injectable } from '@angular/core';
import { ActionResult } from '../entities/actionResult';
import { Ticket } from '../entities/ticket';

export { ActionResult, Ticket };

@Injectable()
export class UserService extends BaseComunicationProvider {
    public address: string = "UserHandler.ashx"; 

    insertTicket(ticketName: string) {
        return new Promise((resolve, reject) => {
            this.sendDataHttp("InsertTicket", JSON.stringify({ Value: ticketName }))
              .then(data => {
                resolve(<ActionResult>data);
              }).catch((err) => {
                  reject(err);
              });
            })
    };

    getAllByChampionship(){
      return new Promise((resolve, reject) => {
          this.sendDataHttp("GetAllByChampionship", JSON.stringify(""))
            .then(data => {
              var json: any = data;
              resolve(<Ticket[]>json.Item);
            }).catch((err) => {
                reject(err);
            });
          })
    }

    cancelMessage(messageId: number) {
      return new Promise((resolve, reject) => {
        this.sendDataHttp("CancelMessage", JSON.stringify({Value: messageId}))
          .then(data => {
            var json: any = data;
            resolve(<string>json.Item);
          }).catch((err) => {
              reject(err);
          });
        })
    }

}



// WEBPACK FOOTER //
// ./src/providers/user.ts